export default "__VITE_ASSET__YC$cK3q0__"